// extracted by mini-css-extract-plugin
export var container = "Panel-module--container--jFfHM";
export var backgroundContainer = "Panel-module--backgroundContainer--nuIJ4";
export var infoSysPortal = "Panel-module--infoSysPortal---FkeK";